import storeFromArea from '../utils/storeFromArea';
import { Action, Dispatch } from 'redux';

export const INIT_REDUCER = 'shared.initReducer';

/**
 * Inicializace shared store.
 * @param area oblast
 * @param store konkrétní store
 */
export function init(area: string, store: any) {
  return {
    type: INIT_REDUCER,
    area,
    store
  };
}

export function initIfNeeded(area: string, reducer: any) {
  return (dispatch: Dispatch, getState: Function) => {
    const currentStore = storeFromArea(getState(), area, false);
    if (currentStore === null) {
      const newStore = reducer();
      dispatch(init(area, newStore));
    }
  };
}

/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */
export function is(action: Action) {
  switch (action.type) {
    case INIT_REDUCER:
      return true;
    default:
      return false;
  }
}
